import { getUser, getUserList , updateUser, createUser, grantAdmin, revokeAdmin, addUserAppRole, removeUserAppRole } from "../../../api/user";
import { useMutation, useQuery } from "./helper";
import { TResponseItemWrapper, TResponseListWrapper } from "../../types/common";
import { TUser } from "../../types/user";

export const useUserList = (params, options) => useQuery<TResponseListWrapper<TUser>>({
    queryKey: ['users', params],
    queryFn: () => getUserList(params),
    ...options
});

export const useUser = (userId: string | number | undefined, options) => useQuery<TResponseItemWrapper<TUser>>({
    queryKey: ['user', userId],
    queryFn: () => getUser(userId!),
    ...options
});

export const useUserUpdate = () => useMutation({
    mutationFn: (user: TUser) => updateUser(user),
});

export const useUserCreate = () => useMutation({
    mutationFn: createUser,
});

export const useGrantAdmin = () => useMutation({
    mutationFn: grantAdmin,
});

export const useRevokeAdmin = () => useMutation({
    mutationFn: revokeAdmin,
});

export const useAddUserAppRole = () => useMutation({
    mutationFn: ({ userEmail, roleName }: { userEmail: string; roleName: string }) => addUserAppRole(userEmail, roleName),
});

export const useRemoveUserAppRole = () => useMutation({
    mutationFn: ({ userEmail, roleName }: { userEmail: string; roleName: string }) => removeUserAppRole(userEmail, roleName),
});
